import { apiFetch, parseApiError } from './client';

function buildQuery(filters = {}) {
  const params = new URLSearchParams();
  const entries = {
    targetStart: filters.targetStart,
    targetEnd: filters.targetEnd,
    lookbackStart: filters.lookbackStart,
    lookbackEnd: filters.lookbackEnd,
    venueId: filters.venueId,
    eventId: filters.eventId,
    accountId: filters.accountId,
  };

  Object.entries(entries).forEach(([key, value]) => {
    if (value === undefined || value === null || value === '') return;
    params.set(key, String(value));
  });

  return params.toString();
}

export async function fetchRevenuePrediction(filters = {}) {
  const query = buildQuery(filters);
  const response = await apiFetch(`/api/revenue/prediction?${query}`, { method: 'GET' });
  if (!response.ok) {
    throw new Error(await parseApiError(response, 'Failed to load revenue prediction'));
  }
  return response.json();
}
